import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components';
import { Authorization, VolunteersList, VolunteerFull, Main } from './pages';
import {
  AUTHORIZATION,
  NAVIGATION,
  PATH,
  VOLUNTEERS,
  MAIN,
} from './constants/navigation';
import utils from './utils';
import { AuthenticationProvider } from './hooks/global/AuthenticationProvider';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route
          path={
            utils.searchByConstant(NAVIGATION, VOLUNTEERS, PATH) + '/:userID'
          }
          element={
            <Layout
              content={
                <AuthenticationProvider>
                  <VolunteerFull />
                </AuthenticationProvider>
              }
            />
          }
        />
        <Route
          path={utils.searchByConstant(NAVIGATION, VOLUNTEERS, PATH)}
          element={
            <Layout
              content={
                <AuthenticationProvider>
                  <VolunteersList />
                </AuthenticationProvider>
              }
            />
          }
        />
        <Route
          path={utils.searchByConstant(NAVIGATION, AUTHORIZATION, PATH)}
          element={<Layout content={<Authorization />} />}
        />
        <Route
          path={utils.searchByConstant(NAVIGATION, MAIN, PATH)}
          element={<Layout content={<Main />} contentWidth="xs" />}
        />
      </Routes>
    </Router>
  );
};

export default App;
